import {
  Group,
  PermissionValues,
  useCurrentWorkspace,
} from '@gripp/shared-logic';
import { GroupAssignmentColumn } from '../../shared/components/groups/groupAssignmentColumn';

const UPDATE_ACCOUNTS_GROUPS = `
  mutation Account($input: UpdateAccountsGroupsInput!) {
    account {
      updateAccountsGroups(input: $input) {
        success
        message
      }
    }
  }
`;

type AccountGroupsButtonProps = {
  groups: Group[];
  entityId: string;
  name: string;
};

const buildInput = (
  entityId: string,
  workspaceId: string,
  added: { id: string }[],
  removed: { id: string }[]
) => ({
  input: {
    addedGroups: added,
    removedGroups: removed,
    accountIds: [entityId],
    workspaceId,
  },
});

export const AccountGroupsButton = ({
  groups,
  entityId,
  name,
}: AccountGroupsButtonProps) => {
  const workspace = useCurrentWorkspace(true);

  if (!workspace?.id) return <></>;

  return (
    <GroupAssignmentColumn
      entityId={entityId}
      entityName={name}
      currentGroups={groups}
      workspaceId={workspace.id}
      mutation={UPDATE_ACCOUNTS_GROUPS}
      buildInput={buildInput}
      cacheKey="account"
      requiredPermission={PermissionValues.account.changeRole}
    />
  );
};
